<div class="z-[25] fixed top-0 h-12 md:h-[88px] w-full">
  <app-header></app-header>
</div>

<div
  id="main"
  class="w-full absolute bottom-0 overflow-auto"
  [ngClass]="isSeatSelectionRoute ? 'top-0' : 'top-12 md:top-[88px]'">
  <router-outlet></router-outlet>
</div>
